import { Zap } from "lucide-react";

const ACTIVE = ["new", "options_sent", "booking_requested"];

const departsSoon = (legs = []) => {
  const first = [...legs].sort((a, b) => `${a.date}${a.time || ""}`.localeCompare(`${b.date}${b.time || ""}`))[0];
  if (!first?.date) return false;
  const todayET = new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });
  if (first.date < todayET) return false;
  return first.date === todayET || new Date(`${first.date}T${(first.time || "00:00").slice(0, 5)}`) - Date.now() <= 24 * 3600 * 1000;
};

export const AsapBadge = ({ trip, testId }) => {
  if (!ACTIVE.includes(trip.status) || !departsSoon(trip.legs)) return null;
  return (
    <span className="inline-flex items-center gap-1 px-2.5 py-1 text-[0.6rem] tracking-[0.18em] uppercase bg-red-600 border border-red-500 text-white font-semibold whitespace-nowrap" data-testid={testId}>
      <Zap size={11} className="fill-white" /> ASAP
    </span>
  );
};
